import { passwordSecurityLevel } from '@/config/default'

export const validPsd = (psd) => {
  let rep = /^[a-zA-Z0-9~!@#$%^&*()_+]{6,20}$/
  return psd ? rep.test(psd) : rep
}
// 密码校验配置（模板所有分支统一用 {{symbols}} 占位符）
const PWD_VALIDATION_RULES = {
  forbidden: /[\s\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]/, // 禁止空格、中文、中文符号
  charSet: 'a-zA-Z0-9?!@#$%^*();\'~.,', // 允许的字符（无变化）
  levels: {
    [passwordSecurityLevel.LOW]: {
      defaultLength: [6, 16],
      regexTemplate: '^[{{charSet}}]{{length}}$'
    },
    [passwordSecurityLevel.MEDIUM]: {
      defaultLength: [8, 16],
      // 关键修正：三个分支统一用 {{symbols}}，无写死符号
      regexTemplate: '^(?=(?=.*[a-zA-Z])(?=.*[0-9])|(?=.*[a-zA-Z])(?=.*[{{symbols}}])|(?=.*[0-9])(?=.*[{{symbols}}]))[{{charSet}}]{{length}}$'
    },
    [passwordSecurityLevel.HIGH]: {
      defaultLength: [8, 16],
      regexTemplate: '^(?=(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])|(?=.*[A-Z])(?=.*[a-z])(?=.*[{{symbols}}])|(?=.*[A-Z])(?=.*[0-9])(?=.*[{{symbols}}])|(?=.*[a-z])(?=.*[0-9])(?=.*[{{symbols}}]))[{{charSet}}]{{length}}$'
    }
  },
  default: {
    defaultLength: [6, 16],
    regexTemplate: '^[{{charSet}}]{{length}}$'
  }
}

// 正则元字符转义工具函数（必须保留）
const escapeRegExp = (str) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // 转义所有特殊字符
}

// 提取并转义符号集（确保无元字符问题）
const SYMBOLS_RAW = PWD_VALIDATION_RULES.charSet.replace(/a-zA-Z0-9/g, '') // 提取：?!@#$%^*();'~.,
const SYMBOLS = escapeRegExp(SYMBOLS_RAW) // 转义后：\?\!\@\#\$\%\^\*\(\)\;\'\~\.\,

// 新密码校验（核心函数，确保所有占位符替换）
export const validNewPsd = (
  psd,
  level,
  min,
  max
) => {
  // 空值校验（避免后续正则报错）
  if (!psd) return false

  // 快速排除禁止字符（提前返回，提升性能）
  if (PWD_VALIDATION_RULES.forbidden.test(psd)) return false

  // 获取当前级别配置（兜底默认值）
  const levelConfig = PWD_VALIDATION_RULES.levels[level] || PWD_VALIDATION_RULES.default

  // 确定长度范围（优先使用传入的min/max，否则用配置默认值）
  const [finalMin, finalMax] = (min && max && min <= max)
    ? [min, max]
    : levelConfig.defaultLength
  const lengthPart = `{${finalMin},${finalMax}}`

  // 替换所有占位符（确保无残留）
  const regexStr = levelConfig.regexTemplate
    .replace(/{{charSet}}/g, escapeRegExp(PWD_VALIDATION_RULES.charSet)) // 转义charSet
    .replace(/{{symbols}}/g, SYMBOLS) // 替换符号集（全局替换，避免遗漏）
    .replace(/{{length}}/g, lengthPart) // 替换长度

  // 生成正则并校验（添加g会导致多次匹配异常，此处不需要）
  const validator = new RegExp(regexStr)
  // console.log('生成的正则：', validator) // 调试用，可删除
  return validator.test(psd)
}
export const validAccount = (text) => {
  let rep = /^[\u4e00-\u9fa5_a-zA-Z0-9]{4,20}$/
  return text ? rep.test(text) : rep
}
